// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserPut
 */
export interface UserPut {
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  invitationId?: string | null;
}

/**
 * Check if a given object implements the UserPut interface.
 */
export function instanceOfUserPut(value: object): value is UserPut {
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function UserPutFromJSON(json: any): UserPut {
  return UserPutFromJSONTyped(json, false);
}

export function UserPutFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPut {
  if (json == null) {
    return json;
  }
  return {
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    invitationId:
      json["invitation_id"] === undefined
        ? undefined
        : json["invitation_id"] === null
        ? null
        : json["invitation_id"],
  };
}

export function UserPutToJSON(json: any): UserPut {
  return UserPutToJSONTyped(json, false);
}

export function UserPutToJSONTyped(
  value?: UserPut | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    invitation_id: value["invitationId"],
  };
}
